
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
 
@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    private baseLoginUrl = `${environment.baseUrl}${environment.api.userLogin}`;
    //private loginUrl = 'https://localhost:44394/api/UserLogin';
    public token: string;
    public userId: string;
    private logger = new BehaviorSubject<boolean>(this.hasToken());

    constructor(private http: HttpClient) { }

    protected hasToken() : boolean {
        return !!localStorage.getItem('authParams');
    }

    isLoggedIn(): Observable<boolean> {
        return this.logger.asObservable();
    }

    getToken(): string {
        var currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
        if (currentUser)
             this.token = currentUser.token;
         else
             this.token = '';

        return this.token;
    }
    
    setLogIn(providerResponse: string) {
        console.log("localStorage", providerResponse);
        localStorage.setItem('authParams', providerResponse);
        this.logger.next(true);
    }
 
    login(email: string, username:string, password: string) {

        const headers = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' })
        };

        const data = {
            email: email,
            username: username,
            password: password
        };

        return this.http.post<any>(this.baseLoginUrl, data, headers)
                        .pipe(catchError(this.handleError));
           
    }
 
    logOut() {
        localStorage.removeItem('authParams');
        this.logger.next(false);
    }

    handleError(error: HttpErrorResponse){
        return throwError(error);
    }
}